var play_icon_rtlignore_default = {
  "shadow": "EQBse",
  "playIcon": "zTcwN"
};
export {
  play_icon_rtlignore_default as default
};
//# sourceMappingURL=play-icon.rtlignore-scss.js.map
